import $ from 'jquery'
import 'rangeslider.js'

import { initSlider, formatNumberAndCurrency } from './helpers'
import { setHomepageSliderCookies } from '../cookies'
import { elementExists } from '../shared'
import { selectors } from '../selectors'

// https://rangeslider.js.org/

// Wrappers
const amountWrappers = [{ selector: selectors.sliders.amountBlogWrapper, index: 1 }]

export const initSliders = () => {
    for (const wrapper of amountWrappers) {
        elementExists(wrapper.selector) && initSlider($(wrapper.selector), updateHandleAmount, wrapper.index)
    }
}

const updateHandleAmount = ($handle, amountVal) => {
    $handle.html(formatNumberAndCurrency(amountVal)) // Set updated handle text

    setHomepageSliderCookies(amountVal, process.env.SLIDER_INIT_DAYS)
}
